export default "__VITE_ASSET__K5RLtY12__"